import type { CtrlApiError } from "@repo/sdk";
import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export type EffectiveSettings = CTRL_SCHEMA["OpenapigenEffectiveSettings"];
export type EffectiveSetting = CTRL_SCHEMA["SettingsEffective"];

/** Prefix shared by every effective-settings key, for revalidation after writes. */
export const EFFECTIVE_SETTINGS_KEY = "settings/effective";

/** Fetch the caller's resolved settings, each with the scope it came from. */
export function useEffectiveSettings(config?: HttpConfiguration) {
  const client = useCtrlClient();

  return useHttp<EffectiveSettings, CtrlApiError>(
    client.token ? EFFECTIVE_SETTINGS_KEY : null,
    async () => await client.getMyEffectiveSettings(),
    config,
  );
}

/** The resolved entry for `key`, if ctrl returned one. */
export function findEffectiveSetting(
  data: EffectiveSettings | undefined,
  key: string,
): EffectiveSetting | undefined {
  return data?.settings?.find((s) => s.key === key);
}
